const formatFeedback = {
  // Format feedback for display (converts line breaks to <br/> and handles bold text)
  formatForDisplay: (feedback) => {
    if (!feedback) return "";
    let formattedText = feedback;

    // Headers (must be processed before other elements)
    formattedText = formattedText
      .replace(/^### (.*?)$/gm, "<h3>$1</h3>")
      .replace(/^## (.*?)$/gm, "<h2>$1</h2>")
      .replace(/^# (.*?)$/gm, "<h1>$1</h1>");

    // Code blocks (must be processed before inline code)
    formattedText = formattedText.replace(
      /```([^`]+)```/g,
      "<pre><code>$1</code></pre>"
    );

    // Inline elements
    formattedText = formattedText
      // Bold (already implemented)
      .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
      // Italic
      .replace(/\*(.*?)\*/g, "<em>$1</em>")
      // Inline code
      .replace(/`([^`]+)`/g, "<code>$1</code>")
      // Links
      .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>');

    // Block elements
    formattedText = formattedText
      // Blockquotes
      .replace(/^>\s*(.+)$/gm, "<blockquote>$1</blockquote>")
      // Ordered lists
      .replace(/^\d+\.\s+(.+)$/gm, "<li>$1</li>")
      .replace(/(<li>.*<\/li>)/s, "<ol>$1</ol>")
      // Unordered lists
      .replace(/^[-*]\s+(.+)$/gm, "<li>$1</li>")
      .replace(/(<li>(?!.*<\/ol>).*<\/li>)/s, "<ul>$1</ul>");

    // Tables
    const tableRegex = /\|(.+)\|\n\|[-|\s]+\|\n((?:\|.+\|\n?)+)/g;
    formattedText = formattedText.replace(
      tableRegex,
      (match, headers, rows) => {
        const headerCells = headers
          .split("|")
          .filter((cell) => cell.trim())
          .map((cell) => `<th>${cell.trim()}</th>`)
          .join("");

        const bodyRows = rows
          .trim()
          .split("\n")
          .map((row) => {
            const cells = row
              .split("|")
              .filter((cell) => cell.trim())
              .map((cell) => `<td>${cell.trim()}</td>`)
              .join("");
            return `<tr>${cells}</tr>`;
          })
          .join("");

        return `<table><thead><tr>${headerCells}</tr></thead><tbody>${bodyRows}</tbody></table>`;
      }
    );

    // Convert line breaks last
    formattedText = formattedText.replace(/\n/g, "<br />");

    return formattedText;
  },

  // Process AI feedback for editing (converts <br/> to line breaks)
  processAIFeedback: (feedback) => {
    if (!feedback) return "";
    let processedText = feedback;

    // Headers
    processedText = processedText
      .replace(/<h3>(.*?)<\/h3>/g, "### $1")
      .replace(/<h2>(.*?)<\/h2>/g, "## $1")
      .replace(/<h1>(.*?)<\/h1>/g, "# $1");

    // Reverse HTML to Markdown
    processedText = processedText
      // Tables
      .replace(/<table>.*?<\/table>/gs, (match) => {
        const headers = match
          .match(/<th>(.*?)<\/th>/g)
          .map((h) => h.replace(/<\/?th>/g, "").trim());
        const rows = match
          .match(/<tr>(?!.*?<th>)(.*?)<\/tr>/g)
          .map((row) =>
            row
              .match(/<td>(.*?)<\/td>/g)
              .map((cell) => cell.replace(/<\/?td>/g, "").trim())
          );

        const headerRow = `| ${headers.join(" | ")} |`;
        const separator = `| ${headers.map(() => "---").join(" | ")} |`;
        const dataRows = rows.map((row) => `| ${row.join(" | ")} |`);

        return `${headerRow}\n${separator}\n${dataRows.join("\n")}`;
      })
      // Lists
      .replace(/<\/?ul>/g, "\n")
      .replace(/<\/?ol>/g, "\n")
      .replace(/<li>(.*?)<\/li>/g, "- $1")
      // Blockquotes
      .replace(/<blockquote>(.*?)<\/blockquote>/g, "> $1")
      // Code blocks
      .replace(/<pre><code>(.*?)<\/code><\/pre>/gs, "```\n$1\n```")
      // Inline elements
      .replace(/<code>(.*?)<\/code>/g, "`$1`")
      .replace(/<strong>(.*?)<\/strong>/g, "**$1**")
      .replace(/<em>(.*?)<\/em>/g, "*$1*")
      .replace(/<a href="(.*?)">(.*?)<\/a>/g, "[$2]($1)")
      // Line breaks
      .replace(/<br\s*\/?>/g, "\n")
      // Clean up extra newlines
      .replace(/\n{3,}/g, "\n\n");

    return processedText;
  },
};

export default formatFeedback;
